export default __webpack_public_path__ + "static/media/Tegu-swivel-bug-2.de41a2b2.jpg";